export type BenefitsProps = {
    benefits?: string[];
};
const Benefits = ({ benefits }: BenefitsProps) => {
    return (
        <ul>
            {benefits?.map((benefit, index) => (
                // biome-ignore lint: lint/suspicious/noArrayIndexKey: this is a static list
                <li key={index}>{benefit}</li>
            )) ?? null}
        </ul>
    );
};

export default Benefits;
